import { createAction } from "../base/action";
import { LANGUAGES } from "../lang";

export const languageChangeAction = createAction("CHANGE_LANG", (language:keyof typeof LANGUAGES) => {
    return {language};
});